<template>
    <div class="breadcrumbs">
        <div class="container-fluid">
            <ul>
                <li
                    :key="index"
                    v-for="(breadCrumbItem, index) in $page.breadcrumb.links">

                    <inertia-link
                        :href="breadCrumbItem.url"
                        v-if="breadCrumbItem.url">
                        <span>{{ breadCrumbItem.text }}</span>
                    </inertia-link>

                    <span v-else>{{ breadCrumbItem.text }}</span>

                    <i
                        class="i-chevron-right"
                        :key="index"
                        v-if="$page.breadcrumb.links.length !== index + 1"></i>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'CoreBreadcrumbs'
    }
</script>

<style lang="scss" scoped>
.breadcrumbs {
    margin: 1.5rem 0;

    .container-fluid {
        padding: 0 2rem;
    }

    ul {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        margin: -0.25rem;

        li {
            margin: 0.25rem;

            a {
                &:hover {
                    span {
                        color: var(--primary);
                    }
                }

                span {
                    color: var(--grey);

                    @include transition(0.3s color);
                }
            }

            span {
                color: var(--text-dark);
                font-weight: bold;
            }
        }

        i {
            margin: 0 0.5rem;
            color: var(--primary);
            font-size: 0.875rem;
        }
    }
}
</style>
